import { render, staticRenderFns } from "./DxDetailTabs.vue?vue&type=template&id=2c33dd9e&scoped=true&"
import script from "./DxDetailTabs.vue?vue&type=script&lang=js&"
export * from "./DxDetailTabs.vue?vue&type=script&lang=js&"
import style0 from "./DxDetailTabs.vue?vue&type=style&index=0&id=2c33dd9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c33dd9e",
  null
  
)

export default component.exports